export default "<p class=\"text-center\">carbon-analytics-footer works!</p>\n";